import {BrowserModule}                  from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule}       from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule}    from '@angular/common/http';
import {NgModule, OnDestroy}            from '@angular/core';
import {NgbModule}                      from '@ng-bootstrap/ng-bootstrap';
import {NavigationEnd, Router}          from "@angular/router";

import {MomentModule}                   from 'angular2-moment';

import {AppComponent}                   from './app.component';
import {AppRoutingModule}               from './app.routing.module';
import {ArticlesModule}                 from "./articles/articles.module";
import {CanDeactivateGuard}             from "./services/miscellaneous/can-deactivate-component";
import {CheckboxAdminComponent}         from './admin/checkbox/checkbox-admin.component';
import {CollegeAdminComponent}          from './admin/college/college-admin.component';
import {CollegeService}                 from "./services/college/college.service";
import {CredentialsInterceptor}         from "./interceptors/credentials.interceptor";
import {DialogService}                  from "./services/miscellaneous/dialog-service";
import {FeedService}                    from "./services/feed/feed.service";
import {LoginAdminComponent}            from "./admin/login/login-admin.component";
import {MessageService}                 from "./services/message/message.service";
import {NewsResolve}                    from "./services/news/news.resolve";
import {NewsService}                    from './services/news/news-service';
import {NewsViewComponent}              from "./articles/feed/news/view/news-view.component";
import {PreviewComponent}               from "./articles/inactives/preview/inactives-preview.component";
import {PageNotFoundComponent}          from "./not-found.component";
import {PhrasesAdminComponent}          from './admin/phrases/phrases-admin.component';
import {PlayerAdminComponent}           from './admin/player/player-admin.component';
import {PlayerService}                  from "./services/player/player.service";
import {PositionAdminComponent}         from './admin/position/position-admin.component';
import {PositionService}                from "./services/position/position.service";
import {RssmanagerEditComponent}        from "./articles/feed/rssmanager/edit/rssmanager-edit.component";
import {SharedModule}                   from "./shared.module";
import {SourceAdminComponent}           from './admin/source/source-admin.component';
import {SourceService}                  from "./services/source/source.service";
import {SportResolve}                   from "./services/sport/sports.resolve";
import {SportService}                   from './services/sport/sport.service';
import {TagAdminComponent}              from './admin/tag/tag-admin.component';
import {TagService}                     from "./services/tag/tag.service";
import {TeamAdminComponent}             from './admin/team/team-admin.component';
import {TeamService}                    from "./services/team/team.service";
import {UserEditorComponent}            from "./admin/users/user-editor.component";
import {UserResolve}                    from "./services/user/user.resolve";
import {UserService}                    from "./services/user/user.service";
import {VendorAdminComponent}           from './admin/vendor/vendor-admin.component';
import {VendorService}                  from "./services/vendor/vendor.service";
import {VersionService}                 from "./services/version/version.service";

import {Subscription}                   from "rxjs/Subscription";
import { MassrosterComponent } from './articles/massroster/massroster.component';
import { MassrosterPreviewComponent } from './articles/massroster/massroster-preview/massroster-preview.component';

/*
IMPORTANT NOTE WHEN ADDING TYPEAHEADS:

When adding a typeahead component, if it is shared between administrative modules and the article
pages, it must be put ONLY into the shared.module.ts file as both a declaration and an export.

*/


@NgModule({

	declarations: [

		AppComponent,
		CheckboxAdminComponent,
		CollegeAdminComponent,
		LoginAdminComponent,
		PageNotFoundComponent,
		PhrasesAdminComponent,
		PlayerAdminComponent,
		PositionAdminComponent,
		SourceAdminComponent,
		TagAdminComponent,
		TeamAdminComponent,
		UserEditorComponent,
		VendorAdminComponent,
		MassrosterComponent,
		MassrosterPreviewComponent,

	],

	imports: [

		BrowserModule,      // This must always be first!
		FormsModule,
		SharedModule,
		ReactiveFormsModule,
		HttpClientModule,
		NgbModule.forRoot(),
		MomentModule,
		ArticlesModule,
		AppRoutingModule    // This module must always be last!

	],

	providers: [

		CanDeactivateGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CredentialsInterceptor,
			multi: true
		},
		CollegeService,
		DialogService,
		FeedService,
		MessageService,
		NewsService,
		NewsResolve,
		PlayerService,
		PositionService,
		SourceService,
		SportService,
		SportResolve,
		TagService,
		TeamService,
		UserResolve,
		UserService,
		VendorService,
		VersionService,

	],

	bootstrap: [

		AppComponent

	],

	entryComponents: [

		// Allows the components to be included in a modal.
		CheckboxAdminComponent,
		CollegeAdminComponent,
		NewsViewComponent,
		PhrasesAdminComponent,
		PlayerAdminComponent,
		PositionAdminComponent,
		PreviewComponent,
		RssmanagerEditComponent,
		SourceAdminComponent,
		TagAdminComponent,
		TeamAdminComponent,
		UserEditorComponent,
		VendorAdminComponent,
    MassrosterPreviewComponent
	],

})


/**
 * This is the main application module.
 *
 * It implements user monitoring by watching the Router changes.
 */
export class AppModule implements OnDestroy {

	navigationSubscription:Subscription;
	userServiceSubscription:Subscription;

	/**
	 * Implement user monitoring by watching the NavigationEnd
	 * behavior in the Router object.
	 *
	 * @param {Router}      router       The Router object to monitor.
	 * @param {UserService} userService  The UserService to perform the update.
	 */
	constructor(

		private router: Router,
		private userService: UserService,

	) {

		// When navigation is complete, track the user's actions.
		this.navigationSubscription = this.router.events.subscribe((e: any) => {

			if (e instanceof NavigationEnd) {

				this.track();

			}

		});

	}


	/**
	 * Unsubscribe to the navigation monitoring to avoid memory leaks.
	 */
	ngOnDestroy():void {

		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}

		if (this.userServiceSubscription) {
			this.userServiceSubscription.unsubscribe();
		}

	}


	/**
	 * Cause the current user's session date/time to be updated for
	 * tracking purposes.
	 */
	track():void {

		this.userServiceSubscription = this.userService.track().subscribe(
			() => {},
			() => {}
		)

	}

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts